export default __webpack_public_path__ + "static/media/tigerbox_touch_coral.fd3579a2.png";